import './styles/globals.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import LearningStages from './components/LearningStages';
import StudySmarter from './components/StudySmarter';
import HowItWorks from './components/HowItWorks';
import AboutUs from './components/AboutUs';
import FAQ from './components/FAQ';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

function HomePage() {
  return (
    <div className="min-h-screen relative overflow-x-hidden text-white bg-[#0c0915]">
      {/* Background Image */}
      <div
        className="fixed inset-0 z-0 bg-cover bg-center bg-no-repeat pointer-events-none"
        style={{ backgroundImage: 'url("/mainBgImg.png")' }}
      />

      {/* Navbar */}
      <Navbar />

      {/* Hero Section */}
      <HeroSection />

      {/* Learning Stages Section */}
      <LearningStages />

      {/* Study Smarter Section */}
      <StudySmarter />

      {/* How It Works Section */}
      <HowItWorks />

      {/* About Us Section */}
      <AboutUs />

      {/* FAQ Section */}
      <FAQ />

      {/* Testimonials Section */}
      <Testimonials />

      {/* CTA Section */}
      <CTASection />

      {/* Footer */}
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
